import { SUPPORT_CHEVRONRIGHT } from '@vodafoneziggo/sandwich';
import { ButtonVariant } from '@vodafoneziggo/sandwich/components/button';
import { Wrapper } from 'components/BaseLayout/components/Wrapper';
import { Button } from 'components/Button';
import { Col, Row } from 'components/Grid';
import React from 'react';
import { createDataTestId, globalContentUtil } from 'utils';

import * as S from './quick-links.styles';

interface LinkObject {
  url: string;
  text: string;
  isExternal?: boolean;
}

interface IQuickLinksProps {
  dataTestIdPrefix?: string;
  links: {
    1: LinkObject;
    2?: LinkObject;
    3?: LinkObject;
    4?: LinkObject;
  };
}

const QuickLink = ({ link, dataTestIdPrefix }: { link: LinkObject; dataTestIdPrefix: string }) => {
  const dataTestId = createDataTestId(link?.text, `${dataTestIdPrefix}-`);

  if (!link) return null;

  if (link.isExternal) {
    return (
      <Button
        buttonVariant={ButtonVariant.DARK}
        rightIcon={SUPPORT_CHEVRONRIGHT}
        isLeftAligned
        isFullWidth
        outline
        href={link.url}
        testid={dataTestId}>
        <span>{link.text}</span>
      </Button>
    );
  }

  return (
    <Button
      buttonVariant={ButtonVariant.DARK}
      rightIcon={SUPPORT_CHEVRONRIGHT}
      isLeftAligned
      isFullWidth
      outline
      to={link.url}
      testid={dataTestId}>
      <span>{link.text}</span>
    </Button>
  );
};

export const QuickLinks = ({ links, dataTestIdPrefix = 'footer-links' }: IQuickLinksProps) => {
  return (
    <S.QuickLinks data-testid={dataTestIdPrefix}>
      <Wrapper>
        <Row>
          <Col>
            <h4>{globalContentUtil.translateToString('global.quickLinksHeader')}</h4>
          </Col>
          <Col m={4} l={6}>
            <QuickLink link={links['1']} dataTestIdPrefix={dataTestIdPrefix} />
            {links['3'] && (
              <>
                <S.QuickLinkDivider />
                <QuickLink link={links['3']} dataTestIdPrefix={dataTestIdPrefix} />
              </>
            )}
          </Col>
          <Col m={4} l={6}>
            {/* @ts-expect-error TS(2322): Type 'LinkObject | undefined' is not assignable to... Remove this comment to see the full error message */}
            <QuickLink link={links['2']} dataTestIdPrefix={dataTestIdPrefix} />
            {links['4'] && (
              <>
                <S.QuickLinkDivider />
                <QuickLink link={links['4']} dataTestIdPrefix={dataTestIdPrefix} />
              </>
            )}
          </Col>
        </Row>
      </Wrapper>
    </S.QuickLinks>
  );
};
